<button (click)="close()"
        class="close icon icon-cross icon-size-16"></button>
<div class="mat-dialog-header">
    <h1>{{'Selectionner mon organisation' | transloco}}</h1>
</div>
<mat-dialog-content>
    <div class="content__header">
        <p class="m-0" [innerHTML]="'Il existe plusieurs organisations avec comme nom' | transloco">
        </p>
        <strong class="content__header__name">{{accountName | escapeHtml}}</strong>
    </div>
    <div class="content__desc"><strong>{{'Selectionnez la votre et connectez-vous :' | transloco}}</strong></div>
    <div class="content__buttons">
        <button class="mat-elevation-z"
                (click)="selectOwner()"
                *ngFor="let account of duplicateAccounts"
                mat-raised-button
                color="accent">
            <div class="content__buttons--infos">
                <p>
                    <span class="content__buttons--name">{{ account.name }}</span>
                    <span class="content__buttons--info">{{ 'Creation: $date$' | transloco: {date: account.created_at  * 1000 | date:'shortDate':undefined:language} }}</span>
                </p>
                <p>
                    <span class="content__buttons--products">{{ '$num$ produit(s)' | transloco: {num: account.products_count || '0'} }}</span>
                </p>
            </div>
        </button>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button class="mat-elevation-z"
            (click)="close()"
            mat-raised-button
            color="accent">
        {{ 'Retour' | transloco }}
    </button>
</mat-dialog-actions>
